var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"ml-3",staticStyle:{"background-color":"rgba(0, 0, 0, 0)"},attrs:{"id":"app"}},[_c('back-button'),_c('v-divider'),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }